import { action } from "satcheljs";
import { IShiftRequestEntity } from "sh-models";

const loadDataForRequest = action(
    "LOAD_DATA_FOR_REQUEST",
    (shiftRequest: IShiftRequestEntity) => ({ shiftRequest: shiftRequest })
);

export default loadDataForRequest;